/*
 * Copyright © 2021-present Tacnode Inc. All rights reserved.
 * The information contained in this software is confidential and proprietary to Tacnode Inc. and its subsidiaries. No part of this software may be used, copied, reproduced, modified, displayed, performed, executed, published, distributed, conveyed, stored, transmitted, or otherwise exploited in any form or by any means, including but not limited to electronic, mechanical, photocopying, recording, transcribing, without the prior written consent of Tacnode Inc.
 * Any violation of the above terms will constitute an infringement of copyright and will be subjected to legal action.
 */
import { Descriptions, DescriptionsProps } from 'antd'
import { useTranslation } from 'react-i18next'
import { ModelBankBalanceDetail } from 'account-client'
import { HoverTips } from '@/components/HoverTips'
import { useTranslateAmount } from '@/hooks/useTranslateAmount'
import { timeFormatter } from '@/utils/timeFormatter'

export function RemittanceDetails(
  props: React.PropsWithoutRef<{
    bankBalanceDetailData: ModelBankBalanceDetail
  }>,
) {
  const { bankBalanceDetailData } = props
  const { t } = useTranslation()
  const { translateAmount } = useTranslateAmount()

  const items: DescriptionsProps['items'] = [
    {
      key: 'counterpartAccountName',
      label: t('Remittance Account Name'),
      children: bankBalanceDetailData.memo.counterpartAccountName as any,
    },
    {
      key: 'counterpartAccountNumber',
      label: t('Remittance Account Number'),
      children: bankBalanceDetailData.memo.counterpartAccountNumber as any,
    },
    {
      key: 'counterpartAccountOpeningBank',
      label: t('Remittance Opening Bank'),
      children: bankBalanceDetailData.memo.counterpartAccountOpeningBank as any,
    },
    {
      key: 'debitFormatted',
      label: t('Remittance Amount'),
      children: translateAmount(bankBalanceDetailData.amountFormatted),
    },
    {
      key: 'gmtTransacted',
      label: t('Transacted on'),
      children: timeFormatter.format(bankBalanceDetailData.memo.gmtTransacted as any),
    },
    {
      key: 'gmtTime',
      label: t('Recharged on'),
      children: timeFormatter.format(bankBalanceDetailData.gmtTime as any),
    },
  ]

  return (
    <HoverTips
      type="info"
      title={t('Details of Corporate Remittance')}
      content={<Descriptions items={items} column={1} size="small" style={{ width: 400 }} />}
      arrow={false}
    >
      {bankBalanceDetailData.memo.counterpartAccountName as any}
    </HoverTips>
  )
}
